import React, { Fragment } from 'react'
import { Block } from '../../components/basic/layout'
import { H2 } from '../../components/basic/text'
import { BorderColor, Gray_100 } from '../../constants/colors'
import { SmallSubstep } from './smallSubstep'
import { Substep } from './substep'

export const Step = ({ state, dispatch, data, stepData }) => {
    const isMobile = state.resize < 1025

    const SubstepPassed = key => {
        let currentSubstepKey = 0;
        for (let i = 0; i < stepData.substeps.length; i++) {
            if (state.substep === stepData.substeps[i].title) {
                currentSubstepKey = i
            }
        }
        if (key < currentSubstepKey) {
            return true
        }
        return false
    }

    const isStepTitleAvailable = stepData && !isMobile && stepData.title

    return (
        <Fragment>
            {isStepTitleAvailable && (
                <Block
                    padding="15px"
                    borderBottom="1px solid"
                    borderColor={BorderColor}
                    background={Gray_100}
                >
                    <H2 textTransform="uppercase" size="32px" line="32px">{stepData.title}</H2>
                </Block>
            )}
            {
                stepData
                && stepData.substeps
                && stepData.substeps.map((substep, key) => {
                    if (state.substep === substep.title) {
                        return <Substep key={`Substep-${key}`} state={state} dispatch={dispatch} data={data} stepData={stepData} substepData={substep} />
                    }
                    if (!isMobile) {
                        if (SubstepPassed(key)) {
                            return (
                                <SmallSubstep
                                    key={`SmallSubstep-${key}`}
                                    state={state}
                                    dispatch={dispatch}
                                    data={data}
                                    substepData={substep}
                                />
                            )
                        }
                    }
                    return null
                })
            }
        </Fragment>
    )
}
